// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

export { default } from './LocaleProvider';
export * from './LocaleProvider';



// WEBPACK FOOTER //
// ./components/LocaleProvider/index.js